module.exports = __webpack_public_path__ + "media/images/forms-icons/file-upload-icon-7b9994dac742ae1862727e9494159d8e.svg";